<p>add-cours works!</p>
